export class Rect {
  x: number;
  y: number;
  width: number;
  height: number;

  constructor(x: number = 0, y: number = 0, width: number = 0, height: number = 0) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  public static fromDOMRect(rect: DOMRect) {
    return new Rect(rect.x, rect.y, rect.width, rect.height);
  }
  public static fromTouchEvent(event: TouchEvent) {
    return Array.from(event.touches).map(touch => new Rect(touch.clientX, touch.clientY));
  }
  public static fromTouch(touch: Touch) {
    return new Rect(touch.clientX, touch.clientY);
  }
  public static fromMouseEvent(event: MouseEvent) {
    return new Rect(event.clientX, event.clientY);
  }

  public add(rect: Rect) {
    return new Rect(this.x + rect.x, this.y + rect.y, this.width + rect.width, this.height + rect.height);
  }

  public subtract(rect: Rect) {
    return new Rect(this.x - rect.x, this.y - rect.y, this.width - rect.width, this.height - rect.height);
  }

  public times(num: number) {
    return new Rect(this.x * num, this.y * num, this.width * num, this.height * num);
  }

  public dist(rect: Rect) {
    return rect;
  }

  public toRadians() {
    return Math.atan2(this.y, this.x); //radians
  }

  public toAngle() {
    var angle = Math.atan2(this.y, this.x); //radians
    // you need to devide by PI, and MULTIPLY by 180:
    var degrees = (180 * angle) / Math.PI; //degrees
    return (360 + Math.round(degrees)) % 360; //round number, avoid decimal fragments
  }

  public copy() {
    return new Rect(this.x, this.y, this.width, this.height);
  }

  public magnitude() {
    const x = this.x;
    const y = this.y;
    return Math.sqrt(x * x + y * y);
  }
}
